import { LoaderService } from './../loder_service/loader.service';
import { DataService } from '../../app/data.service';
import { Storage } from '@ionic/storage';
import { ActivatedRoute, Router,NavigationExtras } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
})
export class PaymentComponent implements OnInit {
  total_price:any;
  pay_mode:any;
  uni_code:any;
  public shipping_charge:any;
  public total_order_amount:any;
  constructor(public toastService:LoaderService, public router:Router,public restApi:DataService, public storage:Storage, public route:ActivatedRoute) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      console.log(JSON.parse(params.total_price))
      this.total_price=JSON.parse(params.total_price);
      this.pay_mode=JSON.parse(params.pay_mode);
      this.shipping_charge=JSON.parse(params.shipping_charge);
      this.total_order_amount=JSON.parse(params.total_order_amount);
      
      
    });
  }
place_oder(){
  this.toastService.showLoader('')
  
    let postpramrs={
      "usersessionid" :localStorage.getItem('user_id'),
       "paymethod" :this.pay_mode
     }
     console.log(postpramrs)
     this.restApi.place_order(postpramrs).subscribe((data:any)=>{
       if(data.result==1){
         
         this.toastService.create('Your order successfully placed')
         this.uni_code=data.uni_code
         let cart_count=0;
         
         localStorage.setItem('cart_count','');

         
    let navigationExtras: NavigationExtras = {
      queryParams: {
      uni_code: JSON.stringify(this.uni_code),
      }
      };
  this.router.navigate(['/thankyou'], navigationExtras); 
         this.toastService.hideLoader()
       }else{
        this.toastService.hideLoader()
       }
     },(error:any)=>{
      this.toastService.hideLoader()
     })
  
}
}
